(function () {
  if (window.umDiaPhotoSpotlightReady) return;
  window.umDiaPhotoSpotlightReady = true;
  var instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    var track = root.querySelector('[data-spotlight-track]');
    var controls = root.querySelector('[data-spotlight-controls]');
    if (!track || !controls) return;
    var cards = Array.from(track.querySelectorAll('[data-spotlight-card]'));
    var prev = controls.querySelector('[data-spotlight-prev]');
    var next = controls.querySelector('[data-spotlight-next]');
    var count = controls.querySelector('[data-spotlight-count]');
    var mobile = window.matchMedia('(max-width: 700px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var current = -1, centering = false, frame = 0, scrollFrame = 0, settle = 0, hover = 0, hoverIndex = -1;
    var measuredWidth = track.clientWidth;
    var controller = new AbortController(), options = {signal: controller.signal};
    function cancelHover() {
      window.clearTimeout(hover); hover = 0; hoverIndex = -1;
    }
    function stop() {
      cancelHover();
      window.cancelAnimationFrame(frame); window.cancelAnimationFrame(scrollFrame);
      window.clearTimeout(settle); frame = 0; scrollFrame = 0; centering = false;
    }
    function offset(index) {
      var box = cards[index].getBoundingClientRect(), viewport = track.getBoundingClientRect();
      return box.left + box.width / 2 - viewport.left - track.clientWidth / 2;
    }
    function mark(index) {
      current = Math.max(0, Math.min(cards.length - 1, index));
      cards.forEach(function (card, i) {
        card.classList.toggle('is-active', i === current);
        var button = card.querySelector('[data-photo-expand]');
        if (button) { if (i === current) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current'); }
      });
      count.textContent = (current + 1) + ' / ' + cards.length;
      prev.disabled = current === 0; next.disabled = current === cards.length - 1;
    }
    function center(smooth) {
      stop();
      if (mobile.matches || current < 0) return;
      if (!smooth || reduced.matches) {
        track.scrollLeft = Math.max(0, track.scrollLeft + offset(current));
        return;
      }
      centering = true;
      var start = null, previous = null;
      function tick(time) {
        if (start === null) start = time;
        var dt = previous === null ? 16 : Math.min(64, time - previous); previous = time;
        var delta = offset(current);
        // Measure the changing image width on every frame, keeping growth and travel together.
        if (time - start >= 460) {
          track.scrollLeft = Math.max(0, track.scrollLeft + delta);
          frame = 0; centering = false; return;
        }
        track.scrollLeft = Math.max(0, track.scrollLeft + delta * (1 - Math.exp(-dt / 72)));
        frame = window.requestAnimationFrame(tick);
      }
      frame = window.requestAnimationFrame(tick);
    }
    function select(index, smooth) {
      if (mobile.matches || !cards.length) return;
      if (!smooth || reduced.matches) root.classList.toggle('is-positioning', true);
      mark(index); center(smooth);
      root.classList.toggle('is-positioning', false);
    }
    function nearest() {
      var chosen = current < 0 ? 0 : current;
      var distance = Math.abs(offset(chosen));
      cards.forEach(function (_, i) {
        var delta = Math.abs(offset(i));
        // A small dead band prevents two neighbours exchanging focus at the midpoint.
        if (delta + 12 < distance) { distance = delta; chosen = i; }
      });
      return chosen;
    }
    controls.hidden = cards.length < 2;
    prev.addEventListener('click', function () { select(current - 1, true); }, options);
    next.addEventListener('click', function () { select(current + 1, true); }, options);
    track.addEventListener('click', function (event) {
      var index = cards.indexOf(event.target.closest('[data-spotlight-card]'));
      if (index >= 0 && current !== index) select(index, true);
    }, options);
    track.addEventListener('focusin', function (event) {
      var index = cards.indexOf(event.target.closest('[data-spotlight-card]'));
      if (index >= 0 && current !== index) select(index, true);
    }, options);
    track.addEventListener('keydown', function (event) {
      if (mobile.matches) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
      event.preventDefault();
      select(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1), true);
    }, options);
    // Only real mouse movement requests a new photo. Moving cards under a stationary
    // cursor must never trigger a chain of selections. A brief pause filters flyovers.
    track.addEventListener('pointermove', function (event) {
      if (mobile.matches || event.pointerType !== 'mouse' || event.buttons || centering) return;
      var index = cards.indexOf(event.target.closest('[data-spotlight-card]'));
      if (index < 0 || index === current) { cancelHover(); return; }
      if (index === hoverIndex) return;
      cancelHover(); hoverIndex = index;
      hover = window.setTimeout(function () { hover = 0; hoverIndex = -1; select(index, true); }, 100);
    }, options);
    track.addEventListener('pointerleave', cancelHover, options);
    track.addEventListener('pointerdown', stop, options);
    track.addEventListener('wheel', stop, {passive: true, signal: controller.signal});
    track.addEventListener('scroll', function () {
      if (mobile.matches || centering || !cards.length) return;
      if (!scrollFrame) scrollFrame = window.requestAnimationFrame(function () {
        scrollFrame = 0;
        if (centering) return;
        var index = nearest();
        if (index !== current) mark(index);
      });
      window.clearTimeout(settle);
      settle = window.setTimeout(function () {
        if (!centering && cards.length && Math.abs(offset(current)) > .5) center(true);
      }, 180);
    }, {passive: true, signal: controller.signal});
    root.addEventListener('shopify:block:select', function (event) {
      var index = cards.indexOf(event.target.closest('[data-spotlight-card]'));
      if (index >= 0) select(index, false);
    }, options);
    function resizeGallery() {
      if (track.clientWidth === measuredWidth) return;
      measuredWidth = track.clientWidth; center(false);
    }
    var resize;
    if ('ResizeObserver' in window) { resize = new ResizeObserver(resizeGallery); resize.observe(track); }
    else window.addEventListener('resize', resizeGallery, options);
    reduced.addEventListener('change', function () { if (reduced.matches) center(false); }, options);
    instances.set(root, function () { stop(); controller.abort(); if (resize) resize.disconnect(); });
    function updateMode() {
      stop();
      controls.hidden = mobile.matches || cards.length < 2;
      if (mobile.matches) {
        track.removeAttribute('tabindex');
        track.removeAttribute('aria-roledescription');
        cards.forEach(function (card) {
          card.classList.toggle('is-active', false);
          var button = card.querySelector('[data-photo-expand]');
          if (button) button.removeAttribute('aria-current');
        });
        track.scrollLeft = 0;
      } else {
        track.setAttribute('tabindex', '0');
        track.setAttribute('aria-roledescription', 'carrossel');
        if (cards.length) select(current < 0 ? Math.floor((cards.length - 1) / 2) : current, false);
      }
    }
    mobile.addEventListener('change', updateMode, options);
    updateMode();
  }
  function initAll(scope) {
    if (scope.matches && scope.matches('[data-photo-spotlight]')) init(scope);
    scope.querySelectorAll('[data-photo-spotlight]').forEach(init);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (destroy, root) { if (event.target.contains(root)) { destroy(); instances.delete(root); } });
  });
  initAll(document);
})();
